import { RouteRecordRaw } from 'vue-router';

export const ppsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../pages/_layout/PPSLayout.vue'),
    meta: { scope: 'pps', title: 'EW PPS' },
    children: [{ path: '', name: 'pps.dashboard', component: () => import('../pages/DashboardView.vue') }],
  },
];
